<template>
  <MDBNavbar expand="lg" light bg="light" position="top" container>
    <MDBNavbarBrand href="#">
      <div style="display:block; text-align:left;">
        <div style="display:inline-block">
          <img src="/images/WYSH_logo.jpg" alt="WYSH Logo" style="height:40px;float:left;display: block;margin-top: -6px;margin-left:-4px">
      <div style="font-size:24px;display:block; margin-top:-14px"><a :href="basePath"  style=" display:block"><span style="font-size: 35px; text-align:left; width:100%; color: #000066; font-weight: 500">WYSH</span></a></div>
        </div>
      <span style="font-size: 12px;  margin-bottom:-10px; margin-top: -6px; display: block;!important;width:100px; color: #3b71ca; font-weight:500; text-transform:uppercase">Worldwide Yearly Screening for Hypospadias</span>
      </div>


    </MDBNavbarBrand>
    <MDBNavbarNav right style="flex-direction: row">

      <MDBNavbarItem v-if="!userInfoStore.userId && !$route.path.includes('register')" :href="basePath + '/register'" >
        Create my account
      </MDBNavbarItem>

      <MDBNavbarItem v-if="!userInfoStore.userId && !$route.path.includes('login')" :href="basePath + '/login'" >
        Log in
      </MDBNavbarItem>


      <MDBNavbarItem v-if="!!userInfoStore.userId" :href="basePath + '/feedback'">
        <MDBTooltip title="Send feedback" placement="bottom">
          <template #reference>
            <i class="far fa-message me-3"></i>
          </template>
        </MDBTooltip>
      </MDBNavbarItem>

      <MDBNavbarItem v-if="!!userInfoStore.userId" :href="basePath + '/help'">
        <MDBTooltip title="Help" placement="bottom">
          <template #reference>
            <i class="far fa-circle-question me-3"></i>
          </template>
        </MDBTooltip>
      </MDBNavbarItem>

      <MDBNavbarItem v-if="!!userInfoStore.userId">
        <MDBDropdown class="nav-item" v-model="dropdown1">
          <MDBTooltip title="Notifications" placement="bottom">
            <template #reference>
              <MDBDropdownToggle
                  tag="a"
                  class="nav-link"
                  @click="dropdown1 = !dropdown1"
              >
                <i class="far fa-bell me-3">
                  <MDBBadge
                      color="danger"
                      v-if="notifications.length > 0"
                      pill
                      notification
                  >
                    {{ notifications.length }}
                  </MDBBadge>
                </i>
              </MDBDropdownToggle>
            </template>
          </MDBTooltip>
          <MDBDropdownMenu style="width:200px">
            <div style="margin-top:10px; margin-left:15px;"><strong>Notifications</strong></div>
            <hr/>
            <div v-if="notifications.length === 0 || notifications.length == null" style="margin-bottom:10px; margin-left:15px;">No notifications</div>

            <div v-for="(notification) in notifications" v-bind:key="notification">
                 <p v-html="notification" style="padding:15px;"/>
            </div>

          </MDBDropdownMenu>
        </MDBDropdown>

      </MDBNavbarItem>

      <MDBNavbarItem v-if="!!userInfoStore.userId">
        <MDBDropdown class="nav-item" style="padding-right:1.5em" v-model="dropdown2">
          <MDBTooltip title="My account" placement="bottom">
            <template #reference>
              <MDBDropdownToggle
                  tag="b"
                  class="nav-link"
                  @click="dropdown2 = !dropdown2"
              >
                <i class="far fa-circle-user me-3"></i>
              </MDBDropdownToggle>
            </template>
          </MDBTooltip>
          <MDBDropdownMenu>
            <div style="margin-top:10px; margin-left:15px;">Welcome {{ userInfoStore.firstName || userInfoStore.email }}!</div>
            <hr/>
            <MDBDropdownItem   :href="basePath + '/account'">My Account</MDBDropdownItem>
            <MDBDropdownItem   :href="basePath + '/privacy'">Privacy</MDBDropdownItem>
            <hr/>
            <MDBDropdownItem  style="text-align: center; margin-bottom:10px; margin-top:-10px" :href="basePath + '/logout'">Logout</MDBDropdownItem>
          </MDBDropdownMenu>
        </MDBDropdown>

      </MDBNavbarItem>
    </MDBNavbarNav>
  </MDBNavbar>

  <MDBAlert
      v-model="alert"
      color="warning"
      position="bottom-left"
      width="98%"
      dismiss
      :autohide="false"
      stacking
  >
    <div v-html="alertMessage" />
    <div v-html="alertMessage" />
  </MDBAlert>
</template>

<script src="./_MainMenu.js" lang="js"></script>
<style src="./_MainMenu.less" lang="less" scoped></style>
